export default class SpecialSelect {
	constructor(container) {
		this.value = container.querySelector('.special_select__value');
		this.selectBox = container.querySelector('.special_select__select_box');
		this.toggle = container.querySelector('.special_select__toggle');
		this.options = container.querySelector('.special_select__options');

		this
			.options
			.querySelectorAll('.special_select__options__option')
			.forEach(option => {
				const
					input = option.querySelector('input'),
					label = option.querySelector('span').cloneNode(true);

				input.addEventListener('click', event => {
					if (input.type === 'radio') {
						if (this.value.firstChild) {
							this.value.replaceChild(label, this.value.firstChild);
						} else {
							this.value.appendChild(label);
						}
					} else {
						if (input.checked) {
							this.value.appendChild(label);
						} else {
							this.value.removeChild(label);
						}
					}

					this.fill();
				});
			});

		this
			.options
			.querySelectorAll('.special_select__options__option input:checked')
			.forEach(input => input.dispatchEvent(new Event('click')));

		window.addEventListener('click', (event) => {
			if (
				!container.contains(event.target) || this.options.contains(event.target)
			) {
				this.toggle.checked = false;
			}
		});

		this.fill();
	}

	fill() {
		this
			.selectBox
			.classList
			.toggle('entry_field__element--filled', !!this.value.textContent);
	}
}
